export const FETCH_BUYER_DETAILS = "FETCH_BUYER_DETAILS";
export const FETCH_BUYER_DETAILS_FAILED = "FETCH_BUYER_DETAILS_FAILED";
